<template>
  <div class="employe pb-4 mb-4 border-bottom">
    <div class="container">
      <div class="row mb-3">
        <div class="col">
          <h6 class="m-0 p-0 pb-2">{{employe.name}}</h6>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <i class="el-icon-info"></i>
          {{employe.cat}}
        </div>
        <div class="col">
          <i class="el-icon-message pr-2"></i>
          <a target="_blank" :href="`mailto:${employe.email}`">{{employe.email}}</a>
        </div>
        <div class="col">
          <i class="el-icon-phone"></i>
          {{employe.phone}}
          <span v-if="employe.ext">Ext. {{employe.ext}}</span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div class="directory-location">
            <i class="el-icon-location"></i>
            {{employe.address}}
            <span v-if="employe.int">{{employe.int}}</span>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div class="directory-organitation">
            <i class="el-icon-menu"></i>
            <span class="pl-2">{{ employe.organization_chart }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Employe',
  props: {
    employe: Object,
  },
};
</script>

<style lang="scss">
.directory-location,
.directory-organitation {
  font-size: 0.9em !important;
}
</style>
